import React, { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  Link,
  Container,
} from "@mui/material";
import CustomButton from "../Components/CustomButton";
import axios from "../axiosInstance";
import { message } from "antd";
import { InputAdornment } from "@mui/material";
import { Person, Phone, Email, LocationOn, Message } from "@mui/icons-material";
import AdmissionEnquiry from "../assets/AdmissionEnquiry.jpg";
import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageTitle from "../Components/PageTitle";
import ContactBanner from "../assets/Contact.png";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "/api/v1/contact/add-contact",
        formData
      );
      if (response.data.success === true) {
        message.success("Enquiry submitted successfully!");
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        message.error(response.data.message || "Failed to submit enquiry");
      }
    } catch (error) {
      message.error(error.response.data.message || "Failed to submit enquiry.");
    }
  };

  return (
    <>
      <Navbar />
      <PageTitle
        title="Contact Us - Shree Mangalam School"
        description="Get in touch with Shree Mangalam School for inquiries about RIMC, Sainik School, and Military School coaching programs. We're here to help you succeed."
        url="/contact"
        keywords="contact Shree Manglam, school coaching contact, RIMC coaching inquiry, Sainik school help, military school coaching support"
      />
      <Header image={ContactBanner} alt={"Contact Us Banner"} />
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh",
          backgroundImage: `url(${AdmissionEnquiry})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.92)",
          },
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 1,
            py: 8,
          }}
        >
          <Grid
            container
            sx={{
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                mt: 3,
                mb: 4,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  color: "#065A79",
                  fontWeight: "bold",
                  mb: 6,
                }}
              >
                Always Here to Help you
              </Typography>

              <Box display="flex" alignItems="center" gap={1.5} mt={2}>
                <LocationOn
                  sx={{
                    color: "#fff",
                    backgroundColor: "#AD1C86",
                    borderRadius: "50%",
                    fontSize: { xs: "35px", md: "35px" },
                    p: 1,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    fontWeight: "500",
                    letterSpacing: 1.5,
                  }}
                >
                  Jaipur-Gudha State Highway (Just on by pass) In Gudha Gorji Raj. pin 333022
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1.5} mt={2}>
                <Phone
                  sx={{
                    color: "#fff",
                    backgroundColor: "#AD1C86",
                    borderRadius: "50%",
                    fontSize: { xs: "35px", md: "35px" },
                    p: 1,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    fontWeight: "500",
                    letterSpacing: 1.5,
                  }}
                >
                  +919928263305
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1.5} mt={2}>
                <Phone
                  sx={{
                    color: "#fff",
                    backgroundColor: "#AD1C86",
                    borderRadius: "50%",
                    fontSize: { xs: "35px", md: "35px" },
                    p: 1,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    fontWeight: "500",
                    letterSpacing: 1.5,
                  }}
                >
                  +919413645511
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1.5} mt={2}>
                <Email
                  sx={{
                    color: "#fff",
                    backgroundColor: "#AD1C86",
                    borderRadius: "50%",
                    fontSize: { xs: "35px", md: "35px" },
                    p: 1,
                  }}
                />
                <Typography>
                  <Link
                    href="mailto:shreemangalamacademy11@gmail.com"
                    sx={{
                      color: "inherit",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                      fontWeight: "500",
                      letterSpacing: 1.5,
                      textDecoration: "none",
                    }}
                  >
                    shreemangalamacademy11@gmail.com
                  </Link>
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                mt: 3,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 1,
                  color: "#065A79",
                  fontWeight: "bold",
                  mb: 5,
                }}
              >
                Ready To Get Started?
              </Typography>
              <TextField
                fullWidth
                label="Full Name"
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                margin="normal"
                InputLabelProps={{
                  sx: {
                    color: "#AD1C86",
                    "&.Mui-focused": {
                      color: "#AD1C86",
                      fontWeight: "bold",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person sx={{ color: "#AD1C86" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&:hover fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#065A79",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "10px",
                    },
                  },
                }}
              />

              <TextField
                fullWidth
                label="Phone"
                placeholder="Enter your phone number"
                name="phone"
                type="number"
                value={formData.phone}
                onChange={handleChange}
                margin="normal"
                InputLabelProps={{
                  sx: {
                    color: "#AD1C86",
                    "&.Mui-focused": {
                      color: "#AD1C86",
                      fontWeight: "bold",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone sx={{ color: "#AD1C86" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& input[type='number']": {
                    MozAppearance: "textfield",
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                  },
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&:hover fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#065A79",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "10px",
                    },
                  },
                }}
              />

              <TextField
                fullWidth
                label="Email"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                margin="normal"
                InputLabelProps={{
                  sx: {
                    color: "#AD1C86",
                    "&.Mui-focused": {
                      color: "#AD1C86",
                      fontWeight: "bold",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email sx={{ color: "#AD1C86" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&:hover fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#065A79",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "10px",
                    },
                  },
                }}
              />

              <TextField
                fullWidth
                placeholder="Enter your message"
                multiline
                rows={3}
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                margin="normal"
                InputLabelProps={{
                  sx: {
                    color: "#AD1C86",
                    "&.Mui-focused": {
                      color: "#AD1C86",
                      fontWeight: "bold",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Message sx={{ color: "#AD1C86", mb: 5 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&:hover fieldset": {
                      borderColor: "#AD1C86",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#065A79",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "10px",
                    },
                  },
                }}
              />
              <Box mt={2}>
                <CustomButton
                  ButtonName={"Send Message"}
                  handleSubmit={handleSubmit}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default Contact;
